import React, { useState } from 'react';
import { FiCalendar } from 'react-icons/fi';

interface DateFilterProps {
  onFilter: (filters: {
    startDate: string | null;
    endDate: string | null;
  }) => void;
}

const formatDate = (date: string | null) => {
  if (!date) return 'dd/mm/yyyy'; // Placeholder
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };
  return new Date(date).toLocaleDateString('en-GB', options);
};

// const toISOStringWithStartTime = (date: string) => {
//   if (!date) return null;
//   const utcDate = new Date(date + "T00:00:00.000Z"); // Ensure UTC format
//   return utcDate.toISOString();
// };

const toISOStringWithStartTime = (date: string | null) => {
  if (!date) return null;

  const utcDate = new Date(date); // Convert to Date object
  const now = new Date(); // Get current UTC time

  return new Date(
    Date.UTC(
      utcDate.getFullYear(),
      utcDate.getMonth(),
      utcDate.getDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds(),
    ),
  ).toISOString();
};

const DateFilter: React.FC<DateFilterProps> = ({ onFilter }) => {
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [showPicker, setShowPicker] = useState(false);

  const handleFilterChange = () => {
    onFilter({
      startDate: startDate ? toISOStringWithStartTime(startDate) : null,
      endDate: endDate ? toISOStringWithStartTime(endDate) : null,
    });
    setShowPicker(false);
  };

  return (
    <div className="relative w-fit">
      {/* Displayed date range */}
      <div
        className="flex items-center justify-between border border-gray-300 rounded-xl px-4 py-2.5 cursor-pointer bg-white shadow-sm"
        onClick={() => setShowPicker(!showPicker)}
      >
        <span className="text-gray-700 text-sm">
          {formatDate(startDate)} - {formatDate(endDate)}
        </span>
        <FiCalendar className="ml-6 w-5 h-5 text-gray-500" />
      </div>

      {/* Date Picker Inputs */}
      {showPicker && (
        <div className="absolute top-12 left-0 bg-white border rounded-xl p-4 shadow-lg w-full">
          <div className="flex flex-col gap-3">
            <input
              type="date"
              value={startDate || ''}
              onChange={(e) => setStartDate(e.target.value)}
              className="border p-2 rounded-md w-full"
            />
            <input
              type="date"
              value={endDate || ''}
              onChange={(e) => setEndDate(e.target.value)}
              className="border p-2 rounded-md w-full"
            />
            <button
              onClick={handleFilterChange}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateFilter;
